import {CircularProgress} from "@mui/material";

export default function GlossarySearchLoader() {
    // Used in GlossaryContent to display loader during
    // debouncing research

    // BUILD
    return (
        <div className={"animate-appear flex justify-center items-center"}>
            <CircularProgress size={"16px"}
                              style={{'color' : '#C0CBDA'}} />
        </div>
    );
}